export default "__VITE_ASSET__CdJnC3tE__"